import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { articles } from '@/mocks/articles';
import { categories, getCategoryBySlug } from '@/mocks/categories';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = getCategoryBySlug(slug || '');

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50 flex items-center justify-center">
        <div className="text-center">
          <h1 className="font-heading text-2xl font-bold text-foreground-800 mb-2">分类不存在</h1>
          <Link to="/" className="text-primary-600 hover:text-primary-700 cursor-pointer">返回首页</Link>
        </div>
      </div>
    );
  }

  const categoryArticles = articles.filter((a) => a.category === category.slug);
  const hotInCategory = categoryArticles.filter((a) => a.isHot);
  const otherArticles = categoryArticles.filter((a) => !a.isHot);

  return (
    <>
      <ScrollToTop />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: `吃瓜爆料 - ${category.name}`,
        description: `${category.description} - 吃瓜爆料${category.name}频道`,
        url: `https://chigua-baoliao.com/category/${category.slug}`,
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'https://chigua-baoliao.com' },
            { '@type': 'ListItem', position: 2, name: category.name },
          ],
        },
      }) }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="py-4">
              <Breadcrumb items={[{ label: '首页', href: '/' }, { label: category.name }]} />
            </div>

            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                <i className={`${category.icon} text-xl text-primary-500`}></i>
              </div>
              <div>
                <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                  {category.name}
                </h1>
                <p className="text-sm text-foreground-500">{category.description}</p>
              </div>
            </div>

            <div className="flex items-center gap-2 my-6 overflow-x-auto hide-scrollbar">
              <Link
                to="/"
                className="flex-shrink-0 px-4 py-1.5 rounded-full text-sm font-medium bg-background-100 hover:bg-background-200 text-foreground-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                全部
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`flex-shrink-0 px-4 py-1.5 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    cat.slug === category.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 hover:bg-background-200 text-foreground-700'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {hotInCategory.length > 0 && (
              <div className="mb-10">
                <h2 className="font-heading text-lg font-bold text-foreground-800 mb-4 flex items-center gap-2">
                  🔥 热门{category.name}爆料
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                  {hotInCategory.map((article) => (
                    <ArticleCard key={article.id} article={article} />
                  ))}
                </div>
              </div>
            )}

            <div className="mb-10">
              <h2 className="font-heading text-lg font-bold text-foreground-800 mb-4">
                全部{category.name}爆料
              </h2>
              <div className="flex flex-col gap-4">
                {otherArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} variant="horizontal" />
                ))}
              </div>
              {otherArticles.length === 0 && (
                <p className="text-center text-foreground-500 py-10">暂无更多内容</p>
              )}
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}